import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "g4sp-sidebar-collapsed"

export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  connect() {
    if (window.innerWidth >= 1024 && localStorage.getItem(STORAGE_KEY) === "1") {
      this.sidebarTarget.classList.add("collapsed")
    }
  }

  disconnect() {
    // Lifecycle cleanup (no timers or listeners to clear)
  }

  toggle() {
    this.sidebarTarget.classList.toggle("open")
    this.overlayTarget.classList.toggle("open")
  }

  close() {
    this.sidebarTarget.classList.remove("open")
    this.overlayTarget.classList.remove("open")
  }

  collapse() {
    this.sidebarTarget.classList.add("collapsed")
    localStorage.setItem(STORAGE_KEY, "1")
  }

  expand() {
    this.sidebarTarget.classList.remove("collapsed")
    localStorage.setItem(STORAGE_KEY, "0")
  }

  toggleCollapse() {
    if (this.sidebarTarget.classList.contains("collapsed")) {
      this.expand()
    } else {
      this.collapse()
    }
  }
}
